__turbopack_context__.v({
  "agreement": "auth-page-module__7PYyba__agreement",
  "authBackNav": "auth-page-module__7PYyba__authBackNav",
  "back": "auth-page-module__7PYyba__back",
  "brand": "auth-page-module__7PYyba__brand",
  "brandContent": "auth-page-module__7PYyba__brandContent",
  "brandCopy": "auth-page-module__7PYyba__brandCopy",
  "brandIcon": "auth-page-module__7PYyba__brandIcon",
  "brandImage": "auth-page-module__7PYyba__brandImage",
  "brandShade": "auth-page-module__7PYyba__brandShade",
  "compact": "auth-page-module__7PYyba__compact",
  "divider": "auth-page-module__7PYyba__divider",
  "error": "auth-page-module__7PYyba__error",
  "eyebrow": "auth-page-module__7PYyba__eyebrow",
  "field": "auth-page-module__7PYyba__field",
  "fieldAction": "auth-page-module__7PYyba__fieldAction",
  "form": "auth-page-module__7PYyba__form",
  "formEnter": "auth-page-module__7PYyba__formEnter",
  "formMeta": "auth-page-module__7PYyba__formMeta",
  "formSide": "auth-page-module__7PYyba__formSide",
  "formWrap": "auth-page-module__7PYyba__formWrap",
  "heading": "auth-page-module__7PYyba__heading",
  "iconAction": "auth-page-module__7PYyba__iconAction",
  "imageEnter": "auth-page-module__7PYyba__imageEnter",
  "inlineLink": "auth-page-module__7PYyba__inlineLink",
  "input": "auth-page-module__7PYyba__input",
  "inputWithAction": "auth-page-module__7PYyba__inputWithAction",
  "logo": "auth-page-module__7PYyba__logo",
  "logoMark": "auth-page-module__7PYyba__logoMark",
  "message": "auth-page-module__7PYyba__message",
  "page": "auth-page-module__7PYyba__page",
  "primary": "auth-page-module__7PYyba__primary",
  "process": "auth-page-module__7PYyba__process",
  "registerPair": "auth-page-module__7PYyba__registerPair",
  "riseIn": "auth-page-module__7PYyba__riseIn",
  "shell": "auth-page-module__7PYyba__shell",
  "social": "auth-page-module__7PYyba__social",
  "socials": "auth-page-module__7PYyba__socials",
});
